<template>
  <div>
      <div v-for="(d, i) in data" :key="i" class="promise-info">
        <div class="inner-item">
          <div class="icon">
            <div class="icon-container">
              <img v-if="d.type == 1" src="/images/icn_yubikiri.svg" class="icon-image">
              <img v-if="d.type == 2" src="/images/icn_gift.svg" class="icon-image">
            </div>
            <div class="icon-info">
              <span v-if="d.type == 1">やくそく</span>
              <span v-if="d.type == 2">ごほうび</span>
            </div>
          </div>
          <div>
            {{d.title}}
            <span class="pay">{{d.pay}}<span class="unit">ペイ</span></span>
            <div class="detail">
              {{d.detail}}
            </div>
          </div>
        </div>
      </div>
      <div v-if="isNoData">
        <i class="fal fa-info-circle"></i> おやくそくはありません
      </div>
  </div>
</template>

<script>

export default {
  props: ['data'],
  computed: {
    isNoData: function () {

      if(Object.keys(this.data).length === 0){
        return true;
      } else{
        return false;
      }
    }
  },
};

</script>

<style lang="scss" scoped>

  .edit-container {
    text-align: right;
    font-size: 14px;
  }

  .promise-info {
    border-bottom: 1px solid #ddd;
    padding: 4px;

    .inner-item {
      display: flex;
      align-items: center;

      .icon {
        padding: 4px 15px 4px 15px;
        position: relative;
        height: 55px;

        .icon-info {
          position: absolute;
          text-align: center;
          font-size: 10px;
          bottom: 5px;
          left: 0;
          right: 0;
        }

      }

      .icon-container{
        text-align: center;

        .icon-image{
          width: 35px;
        }

      }

      .pay {
        display: inline-block;
        padding-left: 10px;
        font-size: 18px;
      }

      .detail {
        font-size: 13px;
      }

      .unit {
        font-size: 13px;
      }
    }
  }


</style>
